export enum Types {
	LOG_IN_REQUEST = '@login/LOG_IN_REQUEST',
	LOG_IN_SUCCESS = '@login/LOG_IN_SUCCESS',
	LOG_IN_FAILURE = '@login/LOG_IN_FAILURE',
	LOG_IN_CHANGE_PASSWORD = '@login/LOG_IN_CHANGE_PASSWORD',

	FIX_LOG_IN = '@login/FIX_LOG_IN',
	LIMPA_LOGIN = '@login/LIMPA_LOGIN',

	LOG_OFF_REQUEST = '@login/LOG_OFF_REQUEST',
	LOG_OFF_AND_RELOAD_REQUEST = '@login/LOG_OFF_AND_RELOAD_REQUEST',

	LOCKED_URL_REQUEST = '@login/LOCKED_URL_REQUEST',

	EXTENDER_TEMPO_PARA_INATIVIDADE = '@login/EXTENDER_TEMPO_PARA_INATIVIDADE',
}

export interface ConsultarUsuariosAcessoState {
	login: Login;
	renovacaoMainframe: string;
	resetSenha: { status: boolean; message: string };
	user: {
		idUsuario: string;
		cpf: string;
		nome: string;
		orgaos: any;
		login?: boolean;
		parametrosSistema: ParametrosLocalidade[];
		permisaoUsuario?: {
			isTemAcessoADM: boolean;
			isTemAcessoGerenciarRelatorio: boolean;
		};
		sgu?: {
			isTemAcessoADM: boolean;
			isTemAcessoGerenciarRelatorio: boolean;
		};
		perfil: UserPerfil | null;
	};
	reload: boolean;
	tempoLogado: number;
	lockedUrl: boolean;
}

export interface ParametrosLocalidade {
	id: number;
	descricao: string;
	sigla: string;
	valor: string;
}

export interface User {
	cpf: string;
	idLocal: number;
	idOrgao: number;
	idCanal: number;
	descCanal: string;
	posto: string;
	digito_posto: string;
	nomePosto: string;
	ip: string;
	parametrosLocalidade: ParametrosLocalidade[] | [];
	idLocalidade: number;
}

export interface Login {
	mainframe: {
		idUsuario: string;
		senhaMainFrame: string;
	};
	user: User;
}

export interface Orgao {
	id: number;
	descricao: string;
	flHabilitado: boolean;
}

export interface LoginRequest {
	cpf: string;
	// senha: string;
}

export interface UserPerfil {
	id: number;
	descricao: string;
	status: {
		id: number;
		descricao: string;
	};
	acessaSgu?: boolean;
}
